export default {
  errorNotAnImage: 'Vorschau unmöglich, die Datei ist kein Bild oder nicht mehr verfügbar.',
};
